import { Model } from '@vuex-orm/core';
import { uuidv4 } from '../../utils/helpers';
import { Currency } from './models';

export class CurrencyRate extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'currency_rates';

  static fields() {
    return {
      id: this.attr(() => uuidv4()),
      from_code: this.attr(null),
      currency_from: this.belongsTo(Currency, 'from_code'),
      to_code: this.attr(null),
      currency_to: this.belongsTo(Currency, 'to_code'),
      rate: this.attr(null),
      recorded_at: this.attr(null),
      updated_at: this.attr(null),
      created_at: this.attr(null),
    };
  }
}

export default CurrencyRate;
